export const getMenuData = [

  // {
  //  category: true,
  //  title: '',
  // },
  // {
  //   title: 'Database',
  //   key: 'database',
  //   url: '/database',
  //   icon: 'database',
  // },
  // {
  //   title: 'Main',
  //   key: 'main',
  //   url: '/main',
  //   icon: 'thunderbolt',
  // },
  {
    title: 'Main',
    key: 'viewscreens',
    url: '/main',
    icon: 'home',
  },
  // {
  //   title: 'Segments',
  //   key: 'segments',
  //   url: '/segments',
  //   icon: 'team',
  // },
  // {
  //   title: 'Informers',
  //   key: 'informers',
  //   url: '/informers/informers-list',
  //   icon: 'sound',
  // },
  {
    title: 'Top matches',
    key: 'top',
    url: '/top-matches',
    icon: 'fire',
  },
  {
    title: 'Custom pages',
    key: 'custom-pages',
    url: '/custom-pages',
    icon: 'file-image',
  },
  // {
  //   title: 'Banners',
  //   key: 'banners',
  //   url: '/banners',
  //   icon: 'picture',
  // },
  {
    title: 'Media',
    key: 'media',
    url: '/media',
    icon: 'picture',
  },
  // {
  //   title: 'Pop-up banners',
  //   key: 'popup-banners',
  //   url: '/popup-banners',
  //   icon: 'gateway',
  // },
  {
    title: 'Splashcreens',
    key: 'splashscreens',
    url: '/splashscreens',
    icon: 'mobile',
  },
  {
    title: 'Fortune wheel',
    key: 'fortune_wheel',
    url: '/fortune-wheel',
    icon: 'reconciliation',
    children: [
      {
        title: 'Fortune wheels',
        key: 'fortune_wheels',
        url: '/fortune-wheel',
        icon: 'bars',
      },
      {
        title: 'Promocodes',
        key: 'fortune_wheels_promocodes',
        url: '/fortune-wheel/promo-codes',
        icon: 'gift',
      },
    ],
  },
  {
    title: 'Privileges',
    key: 'privileges',
    url: '/privileges',
    icon: 'crown',
  },
  {
    title: 'Pages',
    key: 'pages',
    url: '/events',
    icon: 'file',
  },
  {
    title: 'Affiliates',
    key: 'affiliates',
    url: '/affiliates',
    icon: 'cluster',
  },
  {
    title: 'Push-notifications',
    key: 'notifications',
    url: '/push-notifications',
    icon: 'bell',
  },
  // {
  //   title: 'Users',
  //   key: 'accounts',
  //   url: '/users',
  //   icon: 'team',
  // },
  //
  {
    title: 'Profiles',
    key: 'profiles',
    url: '/profiles/users',
    icon: 'user',
    // roles: ['admin'],
    children: [
      {
        title: 'Users',
        key: 'accounts',
        url: '/profiles/users',
        icon: 'link',
        // roles: ['admin'],
      },
      {
        title: 'Whitelist',
        key: 'whitelist',
        url: '/profiles/whitelist',
        icon: 'appstore',
        // roles: ['admin'],
      },
      {
        title: 'Collections',
        key: 'unified-collection',
        url: '/profiles/collections',
        icon: 'deployment-unit',
      },
    ],
  },
  //
  {
    title: 'Analytics',
    key: 'analytics',
    url: '/analytics',
    icon: 'bar-chart',
  },
  {
    title: 'Updates',
    key: 'updates',
    url: '/updates',
    icon: 'rocket',
  },
  // {
  //   title: 'Accounts',
  //   key: 'users',
  //   url: '/accounts',
  //   icon: 'usb',
  // },
  {
    title: 'Subscriptions',
    key: 'subscriptions',
    url: '/subscriptions/matches',
    icon: 'schedule',
  },
  {
    title: 'Reviews',
    key: 'reviews',
    url: '/reviews',
    icon: 'message',
  },
  {
    title: 'Promocode',
    key: 'promocode',
    url: '/promocode',
    icon: 'gift',
  },
  {
    title: 'Icons & Colors',
    key: 'sports',
    url: '/sports',
    icon: 'bg-colors',
  },
  {
    title: 'Gifs',
    key: 'gifs',
    url: '/gifs',
    icon: 'video-camera',
  },
  {
    title: 'Betatests',
    key: 'betatest',
    url: '/betatests',
    icon: 'bug',
  },
  {
    title: 'Emergency mode',
    key: 'emergency',
    url: '/emergency-mode',
    icon: 'notification',
  },
  // {
  //   title: 'Betatests',
  //   key: 'betatest',
  //   url: '/betatests',
  //   icon: 'bug',
  //   roles: ['admin'],
  //   children: [
  //     {
  //       title: 'Betatests',
  //       key: 'betatest',
  //       url: '/betatests/beta',
  //       icon: 'bug',
  //       roles: ['admin'],
  //     },
  //     {
  //       title: 'Users',
  //       key: 'betausers',
  //       url: '/betatests/users',
  //       icon: 'user',
  //       roles: ['admin'],
  //     },
  //   ],
  // },
  {
    title: 'Referral Program',
    key: 'referral_program',
    url: '/referral',
    icon: 'share-alt',
    children: [
      {
        title: 'Referral programs',
        key: 'referral_program_programs',
        url: '/referral/programs',
        icon: 'project',
      },
      {
        title: 'Rulesets',
        key: 'referral_program_rulesets',
        url: '/referral/rulesets',
        icon: 'profile',
      },
      {
        title: 'FAQsets',
        key: 'referral_program_faqsets',
        url: '/referral/faqsets',
        icon: 'question',
      },
      {
        title: 'Avatars',
        key: 'referral_program_avatars',
        url: '/referral/avatars',
        icon: 'aliwangwang',
      },
    ],
  },
  {
    title: 'Refferal promocodes',
    key: 'refferal_promocodes',
    url: '/refferal_promocodes',
    icon: 'file',
  },
  // {
  //   title: 'Encryption',
  //   key: 'encryption',
  //   url: '/encryption',
  //   icon: 'barcode',
  // },
  // {
  //   title: 'Roles & permissions',
  //   key: 'permissions',
  //   url: '/permissions',
  //   icon: 'cluster',
  //   roles: ['admin'],
  // },
  {
    title: 'Settings',
    key: 'settings',
    url: '/settings',
    icon: 'setting',
    roles: ['admin'],
    children: [
      {
        title: 'Apps',
        key: 'apps',
        url: '/settings/apps',
        icon: 'appstore',
        roles: ['admin'],
      },
      {
        title: 'Deeplinks',
        key: 'deeplinks',
        url: '/settings/deeplinks',
        icon: 'link',
        roles: ['admin'],
      },
      {
        title: 'Firebase keys',
        key: 'firebase-keys',
        url: '/settings/firebase-keys',
        icon: 'api',
        roles: ['admin'],
      },
      {
        title: 'Languages',
        key: 'languages',
        url: '/settings/languages',
        icon: 'global',
        roles: ['admin'],
      },
    ],
  },
]
